'use client';

import { createContext, useState, ReactNode } from 'react';

interface OnboardingDrawerContextType {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
}

export const OnboardingDrawerContext =
  createContext<OnboardingDrawerContextType>({} as OnboardingDrawerContextType);

export function OnboardingDrawerProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const onOpenChange = (open: boolean) => setIsOpen(open);

  return (
    <OnboardingDrawerContext value={{ isOpen, onOpenChange }}>
      {children}
    </OnboardingDrawerContext>
  );
}
